import { render, staticRenderFns } from "./BasePaginate.vue?vue&type=template&id=5d75d095&"
import script from "./BasePaginate.vue?vue&type=script&lang=js&"
export * from "./BasePaginate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports